import {WIDGET_TYPES} from "../../../core/consts";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {SliderDisplayEvent} from "../../../containers/slider-container/models/slider-display-event";
import type {CompetitionsSliderWidgetState} from "../models/competitions-slider-widget.state";
import {COMPETITIONS_SLIDER_WIDGET} from "../competition-slider-widget.consts";

export class CompetitionsSliderWidgetDisplayEventHandler extends AnalyticsEventHandler {
  state: CompetitionsSliderWidgetState;
  type = COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.displayEvent;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = SliderDisplayEvent;
  }

  async action(params = {}): Promise<void> {
    params.competitionId = this.state.selectedCompetitionId;
    params.sportTypeId = this.state.appState.context.sportType?.id;
    params.widgetType = WIDGET_TYPES.slider;
    params.partner = this.state.appSettings.publisherSettings.id;
    params.screenResolution = this.state.device.screenWidth;

    super.action(params);
  }
}
